/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Portal_Title_AffiliateInputs */



/**
* | output |
* | --- |
* | "Affiliate Portal" |
*
* @param {Partner_Portal_Title_AffiliateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_portal_title_affiliate = /** @type {((inputs?: Partner_Portal_Title_AffiliateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Portal_Title_AffiliateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Affiliate-Portal")
	return /** @type {LocalizedString} */ ("Affiliate Portal")
});